/**
 * @name results.controller:Accordion
 * @description
 * # Accordion
 * Basic accordion. Multiple panes can be expanded. Array of panes generated from
 * view with data-ng-init service. Accordion preset only from medium breakpoint,
 * on smaller breakpoints all panes are expanded by default.
 */
export default function ($scope, $location, $timeout, userPreference) {
    'ngInject';

    /**
     * Initial selected pane for accordion
     * @type {object} Object of panes states. Generated from view with data-ng-init service
     * @type {null|text} currentScreenSize
     */
    let keys;
    const panes = {};
    const expandText = 'Expand All';
    const collapseText = 'Close All';

    /**
     * Getter for panes object
     * @return {object} Object of panes states
     */
    $scope.getPanes = () => panes;

    /**
     * Getter for expandText
     * @returns {string}
     */
    $scope.getExpandText = () => expandText;

    /**
     * Getter for collapseText
     * @returns {string}
     */
    $scope.getCollapseText = () => collapseText;

    /**
     * Set keys with keys of panes
     */
    $scope.updateKeys = () => {
        keys = Object.keys($scope.getPanes());
    };

    /**
     * Getter for keys
     * @return {Array} Current screen size
     */
    $scope.getKeys = () => keys;

    /**
     * Get text of button, depends on current state of panes
     * @returns {string}
     */
    $scope.getExpandCollapseText = () => {
        const state = $scope.checkPanesState();
        return state ? $scope.getExpandText() : $scope.getCollapseText();
    };

    /**
     * Get current pane state
     * @return {boolean} State of current pane
     */
    $scope.getPaneState = (index) => panes[index];

    /**
     * Expand current pane
     * @param {number} index Index of current pane.
     */
    $scope.expandPane = (index) => {
        panes[index] = true;
    };

    /**
     * Collapse current pane
     * @param {number} index Index of current pane.
     */
    $scope.collapsePane = (index) => {
        panes[index] = false;
    };

    /**
     * Check all panes for collapse state
     * @returns {boolean}
     */
    $scope.checkPanesState = () => {
        let panesState = false;
        const panelist = $scope.getPanes();

        Object.keys(panelist).forEach(key => {
            if (!panelist[key]) {
                panesState = true;
            }
        });

        return panesState;
    };

    /**
     * Depend on state of panes collapse or expand all
     */
    $scope.expandCollapseAllPanes = () => {
        if ($scope.checkPanesState()) {
            $scope.expandAllPanes();
        } else {
            $scope.collapseAllPanes();
        }
        userPreference.toggle(userPreference.TYPE_ACCORDION_STATE);
    };

    /**
     * Check is current pane selected and appropriate breakpoint is viewed
     * @param {number} index Index of pane to check.
     * @return {boolean}
     */
    $scope.isPaneSelected = index =>
        $scope.getPaneState(index);

    /**
     * Expand each pane
     */
    $scope.expandAllPanes = () => {
        const panesKeys = $scope.getKeys();

        panesKeys.forEach((element) => {
            $scope.expandPane(element);
        });
    };

    /**
     * Collapse each pane
     */
    $scope.collapseAllPanes = () => {
        const panesKeys = $scope.getKeys();

        panesKeys.forEach((element) => {
            $scope.collapsePane(element);
        });
    };

    /**
     * Select pane. Collapse or expand current pane, depends on it initial state.
     * If scroll flag is set, add hash to url
     * and scroll page to appropriate pane
     * @param {number} index Index of pane that was selected
     * @param {boolean} scroll Flag for adding hash and scrolling the page
     */
    $scope.selectPane = (index) => {
        if ($scope.isPaneSelected(index)) {
            $scope.collapsePane(index);
        } else {
            $scope.expandPane(index);
        }
    };

    /**
     * Init controller, set current screen size, check hash and
     * add handler for 'window' on resize event
     */
    $scope.init = () => {
        $scope.updateKeys();
    };
}



// WEBPACK FOOTER //
// ./src/js/controllers/accordion.js